import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IApiResult } from '../shared/models/api-result';
import { ApiUrlProvider } from './api-url.provider';

@Injectable({
  providedIn: 'root'
})
export class HealthCheckService {
  constructor(
    private http: HttpClient,
    private apiUrlProvider: ApiUrlProvider) { }

    healthCheck(): Observable<IApiResult<boolean>>{
      const ts = new Date().getTime();
      return this.http.get<IApiResult<boolean>>(`${this.apiUrlProvider.url}/HealthCheck?${ts}`);
    }
}
